import { BreakpointsMinQuery } from '@ab-core/breakpoints';
import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const DesktopBarWrapper = styled.div`
    height: 100px;
    display: flex;
`;

export const VerticalDivider = styled.div`
    height: 100px;
    width: 1px;
    border-left: 1px solid ${Colors.gray15};
`;

export const LinkWrapper = styled.div`
    display: flex;
    gap: ${SPACING.SMALL_2};
    padding: ${SPACING.SMALL_5};
    justify-content: center;
    background-color: ${Colors.primary};
    color: ${Colors.white};
    align-items: center;
    width: auto;
    cursor: pointer;
    @media ${BreakpointsMinQuery.lg} {
        padding: ${SPACING.MEDIUM_2};
    }
`;
